var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-screen flex w-full bg-img vx-row no-gutter justify-center"},[_c('div',{staticClass:"vx-col w-full md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"},[_c('checkout')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }